// extracted by mini-css-extract-plugin
export default {"wrapper":"Description_wrapper__R9p1y","description":"Description_description__I8ajw"};